import { Injectable  } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionAlertService {

  private audio = new Audio('assets/sounds/session-warning.mp3');
  private flashInterval: any;
  originalTitle: string = 'Sofy Lab';

  async requestPermission(): Promise<void> {
    if ('Notification' in window && Notification.permission === 'default') {
      await Notification.requestPermission();
    }
  }

  alertUser(message: string) {
    // Browser notification
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification('Session Expiring Soon', {
        body: message,
        icon: 'assets/icons/sofy-icon.png',
      });

      notification.onclick = (event) => {
        event.preventDefault();
        notification.close();
        window.focus();
        setTimeout(() => {
          window.focus();
        }, 10);
      };
    }

    // Audio alert
    this.audio.play().catch(() => {});

    // Tab title flash
    if (this.flashInterval) {
      clearInterval(this.flashInterval);
    }
    this.originalTitle = document.title;
    let flashing = true;
    this.flashInterval = setInterval(() => {
      document.title = flashing ? 'Session Expiring soon' : (this.originalTitle as string);
      flashing = !flashing;
    }, 1000);
  }

  clearTabFlashing(){
    if (this.flashInterval) {
      clearInterval(this.flashInterval);
      this.flashInterval = null;
    }
    if (this.originalTitle !== null) {
      document.title = 'Sofy Lab';
    }
  }
}
